import { render, staticRenderFns } from "./EditableColumnTypeCheckBox.vue?vue&type=template&id=9e38619c&scoped=true&"
import script from "./EditableColumnTypeCheckBox.vue?vue&type=script&lang=js&"
export * from "./EditableColumnTypeCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e38619c",
  null
  
)

export default component.exports